import React from 'react'
import Footer from '../Footer'
import RouteChangeTracker from '../RouteChangeTracker'
import ReferralBanner from '../ReferralBanner'
import Navbar from '../../new-dashboard/components/Navbar'
import {WrapperBox} from './styles'

type Props = {
  children: React.ReactNode
  showHero?: boolean
  hideNavbar?: boolean
  hideFooter?: boolean
  showCompleteText?: boolean
}

const View = ({children, hideNavbar, hideFooter}: Props) => {
  return (
    <>
      <RouteChangeTracker />
      {!hideNavbar && <Navbar />}
      <WrapperBox $isNavbarHidden={hideNavbar}>{children}</WrapperBox>
      {!hideFooter && (
        <>
          <ReferralBanner />
          <Footer />
        </>
      )}
    </>
  )
}

export default View
